import authOnEnter from 'enrollment-platform/authOnEnter'
import BenefitIntegrationsGate from './pages/BenefitIntegrationsGate'
import ListBenefitIntegrations from './pages/ListBenefitIntegrations/ListBenefitIntegrations'
import IdeonConfig, { IdeonAgentDetail } from './pages/IdeonConfig'
import NoyoIssues from './pages/NoyoIssues'
import {
  BENEFIT_INTEGRATIONS,
  IDEON_AGENT_DETAIL,
  IDEON_CONFIG,
  NOYO_ISSUES,
} from './paths'
import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'

const BenefitIntegrationsRoutes = {
  path: BENEFIT_INTEGRATIONS,
  component: BenefitIntegrationsGate,
  onEnter: (_nextState, _replace, callback) => {
    authOnEnter({
      allowedRoles: [ROLE_PLATFORM_HIXME_ADMIN],
      callback,
    })
  },
  indexRoute: {
    component: ListBenefitIntegrations,
  },
  childRoutes: [
    { path: IDEON_CONFIG, component: IdeonConfig },
    { path: IDEON_AGENT_DETAIL, component: IdeonAgentDetail },
    { path: NOYO_ISSUES, component: NoyoIssues },
  ],
}

export default BenefitIntegrationsRoutes
